import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HealthScoreGuageComponent} from './health-score-guage.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [HealthScoreGuageComponent],
  exports: [HealthScoreGuageComponent],
})
export class HealthScoreGuageModule {
}


